// carBrandUtils.js  (updated)
// Maps a recognized brand prefix (as it appears in raw vehicle descriptions,
// uppercase) to how it should be displayed. The keys double as the list of
// recognized brands used to detect where the brand ends and the rest of the
// description begins. In that scenario, have the same value in the key and
// value to preserve the original casing of the brand.
const BRAND_DISPLAY = {
  'MERCEDES-BENZ': 'Mercedes-Benz',
  'MERCEDES BENZ': 'Mercedes Benz',
  'LAND ROVER': 'Land Rover',
  'M A N': 'MAN',
  'ALFA ROMEO': 'Alfa Romeo',
  'ASTON MARTIN': 'Aston Martin',
  VOLKSWAGEN: 'Volkswagen',
  FERRARI: 'Ferrari',
  PORSCHE: 'Porsche',
  MITSUBISHI: 'Mitsubishi',
  MASERATI: 'Maserati',
  INTERNATIONAL: 'International',
  DAIMLER: 'Daimler',
  NISSAN: 'Nissan',
  TOYOTA: 'Toyota',
  HYUNDAI: 'Hyundai',
  HONDA: 'Honda',
  PEUGEOT: 'Peugeot',
  OPEL: 'Opel',
  VOLVO: 'Volvo',
  IVECO: 'Iveco',
  COLT: 'Colt',
  FORD: 'Ford',
  HINO: 'Hino',
  MAZDA: 'Mazda',
  MG: 'MG',
  JEEP: 'Jeep',
  DODGE: 'Dodge',
  BMW: 'BMW',
  SAAB: 'Saab',
  GWM: 'GWM',
  BYD: 'BYD',
};

const BRANDS = Object.keys(BRAND_DISPLAY);

const titleCase = (str) =>
  str.toLowerCase().replace(/(^|\s|-)[a-z]/g, (m) => m.toUpperCase());

export function getBrand(description = '') {
  if (!description) return '';

  const upper = description.toUpperCase().trim();

  const found = BRANDS.find((b) => upper.startsWith(b));
  if (found) {
    return BRAND_DISPLAY[found];
  }

  const firstWord = description.trim().split(/[\s/\\-]+/)[0];
  return titleCase(firstWord);
}

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Splits a vehicle description into its brand-aware-cased brand and the
// remaining description, e.g. "JETOUR T1 1.5T" -> { brand: "Jetour", rest: "T1 1.5T" }
export function splitBrandDescription(raw = '') {
  if (!raw) return { brand: '', rest: '' };
  const brand = getBrand(raw) || '';
  const rest = brand
    ? raw.replace(new RegExp(`^${escapeRegExp(brand)}\\s*`, 'i'), '').trimEnd()
    : raw.trimEnd();
  return { brand, rest };
}

// Title-cases the brand (first word/phrase) of a vehicle description, e.g.
// "JETOUR" -> "Jetour", and leaves the remainder of the description as-is
// (only trimming trailing whitespace).
export function formatSearchDescription(raw = '') {
  if (!raw) return '';
  const { brand, rest } = splitBrandDescription(raw);
  return (brand ? `${brand}${rest ? ' ' : ''}` : '') + rest;
}
